import { render, staticRenderFns } from "./ListItemBoxSchool.vue?vue&type=template&id=792b597b&scoped=true&lang=pug&"
import script from "./ListItemBoxSchool.vue?vue&type=script&lang=ts&"
export * from "./ListItemBoxSchool.vue?vue&type=script&lang=ts&"
import style0 from "./ListItemBoxSchool.vue?vue&type=style&index=0&id=792b597b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792b597b",
  null
  
)

export default component.exports